import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import defaultObjEquals from '_legacy/components/grid/columnDefaults/defaultObjEquals';
import DateComparator from '_legacy/components/grid/comparators/DateComparator';
import DateEditor from '_legacy/components/grid/editors/DateEditor';
import DefaultDateTimeFormatter from '_legacy/components/grid/formatters/DefaultDateTimeFormatter';

export const updatedTimeHeading = {
    colId: 'updatedDateTime',
    headerName: 'Updated On',
    field: 'lastUpdatedDateTimeByUser',
    valueFormatter: DefaultDateTimeFormatter,
    cellEditorFramework: DateEditor,
    editable: false,
    equals: defaultObjEquals,
    comparator: DateComparator,
    width: 132,
    type: ['privatable'],
    excelExportFormat: 'datetime',
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filter: 'dateFilter',
    hide: true,
};
